import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import Typography from '@mui/material/Typography'
import { formatDateTime } from '../../../../utils/formatters/date'
import { formatCurrency } from '../../../../views/helpers/utils'
import { FLAG_LABEL, MovementRow } from './types'
import DeltaPill from './cells/DeltaPill'
import CounterpartyCell from './cells/CounterpartyCell'
import MovementCell from './cells/MovementCell'
import Mark from './cells/Mark'

const columns: GridColDef<MovementRow>[] = [
	{
		field: 'date',
		headerName: 'Date',
		width: 170,
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => {
			// Two different reasons a date is not the moment stock moved, each with its own
			// explanation: a legacy transfer never recorded one, an in-transit one has not
			// happened yet. Both render as "~". They co-occur — only legacy transfers sit in
			// PROCESSING — and the provisional explanation wins because it is the one that
			// will change, on receipt.
			const imprecise = ( [ 'provisional_date', 'approximate_date' ] as const )
				.find( ( flag ) => params.row.flags.includes( flag ) )
			return imprecise
				? <Mark title={FLAG_LABEL[ imprecise ]}>~ {formatDateTime( params.row.date )}</Mark>
				: <span>{formatDateTime( params.row.date )}</span>
		},
	},
	{
		field: 'label',
		headerName: 'Type',
		flex: 1,
		minWidth: 220,
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => <MovementCell row={params.row} />,
	},
	{
		field: 'counterparty',
		headerName: 'Reference',
		flex: 1,
		minWidth: 190,
		sortable: false,
		valueGetter: ( _value, row ) => row.counterparty.display,
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => <CounterpartyCell row={params.row} />,
	},
	{
		field: 'actor',
		headerName: 'Who',
		width: 150,
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => (
			params.row.actor
				? <Typography variant="body2">{params.row.actor}</Typography>
				: <Typography variant="body2" color="text.disabled">No actor recorded</Typography>
		),
	},
	{
		field: 'costPerUnit',
		headerName: 'Cost/unit',
		width: 110,
		align: 'right',
		headerAlign: 'right',
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => (
			<Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums' }}>
				{params.row.costPerUnit !== null ? formatCurrency( params.row.costPerUnit.toString() ) : '—'}
			</Typography>
		),
	},
	{
		field: 'delta',
		headerName: 'Change',
		width: 120,
		align: 'right',
		headerAlign: 'right',
		renderCell: ( params: GridRenderCellParams<MovementRow> ) => <DeltaPill row={params.row} />,
	},
]

export default columns
